import * as React from 'react';

const Tail = (props: React.SVGAttributes<SVGElement>) => (
	<svg viewBox="0 0 17 16" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.493 0l2.416 11.012c.694 3.102-2.688 5.536-5.375 3.832L0 8.821S14.347.406 14.493 0z"
			fill="currentColor"
		/>
	</svg>
);

export default Tail;
